var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './StakeholderSelector.scss';
import classNames from 'classnames';
import { SonarStakeholder } from './SonarStakeholder';
import { Space } from 'antd';
import { useStakeholders } from '@hooks';
import React, { useMemo } from 'react';
import { SonarSelector } from './SonarSelector';
export const StakeholderSelector = (_a) => {
    var { avatar, className, direction = 'vertical', placeholder, popupClassName, stakeholderType, value, withLatest } = _a, props = __rest(_a, ["avatar", "className", "direction", "placeholder", "popupClassName", "stakeholderType", "value", "withLatest"]);
    const stakeholders = useStakeholders(withLatest);
    const isMultiple = Array.isArray(value);
    const placeholderNode = useMemo(() => React.createElement(SonarStakeholder, { avatar: avatar, placeholder: placeholder, stakeholderId: -1 }), [avatar, placeholder]);
    const options = useMemo(() => {
        const isSelected = (stakeholderId) => (isMultiple ? value === null || value === void 0 ? void 0 : value.includes(stakeholderId) : stakeholderId === value);
        return (stakeholderType ?
            stakeholders.filter((stakeholder) => stakeholder.stakeholderType === stakeholderType) :
            stakeholders)
            .filter((stakeholder) => !stakeholder.isLocked || isSelected(stakeholder.stakeholderId))
            .map((stakeholder) => {
            var _a, _b;
            return ({
                className: classNames({ disabled: stakeholder.isLocked }),
                label: React.createElement(SonarStakeholder, { avatar: avatar, stakeholderId: (_a = stakeholder === null || stakeholder === void 0 ? void 0 : stakeholder.stakeholderId) !== null && _a !== void 0 ? _a : -1 }),
                optionLabel: React.createElement(SonarStakeholder, { avatar: avatar, showTooltip: true, stakeholderId: (_b = stakeholder === null || stakeholder === void 0 ? void 0 : stakeholder.stakeholderId) !== null && _b !== void 0 ? _b : -1 }),
                searchValue: stakeholder.name,
                value: stakeholder.stakeholderId
            });
        });
    }, [avatar, isMultiple, stakeholderType, stakeholders, value]);
    const readOnlyDisplay = useMemo(() => React.createElement(Space, { direction: direction, size: 4, wrap: true }, isMultiple ?
        value === null || value === void 0 ? void 0 : value.map((stakeholderId) => React.createElement(SonarStakeholder, { key: stakeholderId, showTooltip: true, stakeholderId: stakeholderId })) :
        React.createElement(SonarStakeholder, { key: value, showTooltip: true, stakeholderId: Number(value) })), [direction, isMultiple, value]);
    const hasValue = Boolean(isMultiple ? value === null || value === void 0 ? void 0 : value.length : value);
    return (React.createElement(SonarSelector, Object.assign({}, props, { className: classNames('stakeholder-selector', className), direction: direction, options: options, placeholder: placeholderNode, popupClassName: classNames('stakeholder-space-conscious-owner-label', popupClassName), readOnlyDisplay: hasValue ? readOnlyDisplay : null, showArrow: true, value: value })));
};
